export default __webpack_public_path__ + "static/media/SoberanoOpen.48887358.jpg";